import Scroller from "../../Scroller/Scroller";
import {gsap} from "gsap";

const Popup = {

    init() {
        this.el = $('[component="Popup"]');
        this.closeBtn = this.el.find('.close');
        this.bind();
        this.initOpener();
    },

    initOpener(el) {
        this.opener = $('[popup]');
        this.opener.click(function (evt) {
            evt.preventDefault();
            Popup.open($(this).attr('popup'), $(this).attr('popup-color'));
        });
    },

    bind() {
        this.closeBtn.click(function () {
            Popup.close($(this))
        })
    },

    close(button) {
        this.isVisible = false;
        const popupEl = button.closest('[component="Popup"]')
        popupEl.removeClass('visible');

        gsap.to(popupEl.find('.inner'), {
            opacity: 0, scale: 0.75, duration: 0.5, ease: "back.out(3)"}
        );
        Scroller.smoother.paused(false);
    },

    open(popup, color) {
        console.log(popup, color)
        this.isVisible = true;
        const popupEl = $('[component="Popup"][name=' + popup + ']');
        popupEl.attr('color', color).addClass('visible');

        gsap.to(popupEl.find('.inner'), {
           opacity: 1, scale: 1, duration: 0.5, ease: "back.out(3)"
        });

        Scroller.smoother.paused(true);
    },
}

export default Popup;